import React from 'react';
import { Box } from '@material-ui/core';

import AdminSelectMenyLightAdConfigureSlot from './AdminSelectMenyLightAdConfigureSlot';
import SelectRestaurant from './SelectRestaurant';

import { isEqual } from 'lodash-es';
import SelectAdAction from './SelectAdAction';
import SelectAdDestination from './SelectAdDestination';
import ShowDebugJson from 'src/components/ShowDebugJson';
import SelectFoodDetail from './SelectFoodDetail';
import SelectFoodMenuCategory from './SelectFoodMenuCategory';
import AdConfigureSlotSubform from './AdConfigureSlotSubform';

import ShowDebug from 'src/components/ShowDebug';

function getDataById(all_data, wanted_id) {
  let found = false;
  let found_data = {};
  for (let i = 0; i < all_data.length; i++) {
    if (all_data[i].id == wanted_id) {
      found = true;
      found_data = all_data[i];
      break;
    }
  }

  if (found) {
    return found_data;
  } else {
    return undefined;
  }
}

export default function FormMenyLightAdConfig({
  formik,
  food_details,
  all_advertisement_result,
}) {
  return (
    <>
      <ShowDebug>form meny light ad config</ShowDebug>
      <AdminSelectMenyLightAdConfigureSlot
        formik={formik}
        all_advertisement_result={all_advertisement_result}
      />

      <AdConfigureSlotSubform formik={formik} food_details={food_details} />
    </>
  );
}
